import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects'
import axios from 'axios'
import {
  acceptAction,
  rejectAction,
} from '@Infowijs-eng/component-library/modules/reduxPromiseHelpers'
import { debounceAction } from '@Infowijs-eng/component-library/modules/authentication'
import { serviceEndpoints } from '@Infowijs-eng/component-library/modules'
import actionTypes from '../../action-types'
import createCustomer from '../../actions/customers/createCustomer'
import setCustomer from '../../actions/customers/setCustomer'
import awaitAccessToken from '../../modules/awaitAccessToken'

const onCreateCustomer = function* onCreateCustomer() {
  yield takeLatest(actionTypes.CUSTOMERS.CREATE, function* onCreateCustomerSaga(action) {
    const accessToken = yield call(awaitAccessToken)
    const { payload } = action
    let response

    try {
      response = yield call(axios, {
        url: `${serviceEndpoints.customers}`,
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'X-Infowijs-Client': 'nl.infowijs.admin',
          'Content-Type': 'application/vnd.infowijs.v1+json',
          Accept: 'application/vnd.infowijs.v1+json',
        },
        data: payload,
      })
    } catch (e) {
      if (e.response.status === 401) {
        yield debounceAction(function* reCreateCustomer() {
          yield put(createCustomer(payload))
        })
      }

      rejectAction(action, e.response.data && e.response.data.errors)
      return
    }

    yield put(setCustomer(response.data.data))

    acceptAction(action, response.data.data)
  })
}

export default onCreateCustomer
